import { render, staticRenderFns } from "./CreateOwner.vue?vue&type=template&id=1cd2ff84&scoped=true"
import script from "./CreateOwner.vue?vue&type=script&lang=js"
export * from "./CreateOwner.vue?vue&type=script&lang=js"
import style0 from "./CreateOwner.vue?vue&type=style&index=0&id=1cd2ff84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd2ff84",
  null
  
)

export default component.exports